import type { FilterModeType } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";

export const searchPanelContextDict = {
    mainSidebar: "main_sidebar",
    expandedAllTab: "expanded_all_tab",
} as const;

export type SearchPanelContext = (typeof searchPanelContextDict)[keyof typeof searchPanelContextDict];

export const FILTER_MODE_TO_EVENT_NAME: Readonly<Record<FilterModeType, string>> = {
    "ai-agent": "AI prospecting",
    "filters-list": "manual filters",
};
